import { render, staticRenderFns } from "./TwoRowWithTag.vue?vue&type=template&id=0c5b339c&scoped=true"
import script from "./TwoRowWithTag.vue?vue&type=script&lang=ts"
export * from "./TwoRowWithTag.vue?vue&type=script&lang=ts"
import style0 from "./TwoRowWithTag.vue?vue&type=style&index=0&id=0c5b339c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5b339c",
  null
  
)

export default component.exports